import { MenuItem } from "@mui/material";
import { useFormikContext } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getNomenclatures, getProviderServicesByNomenclature } from "../../../../actions/providedServices";
import { StyledProviderProvidedServiceForm } from "../../../styled/providers";
import FormikAutocomplete from "../../formik/formikAutocomplete";
import FormikSelect from "../../formik/formikSelect";
import FormikSwitch from "../../formik/formikSwitch";
import FormikTextField from "../../formik/formikTextField";
import CircularLoading from "../../loadingData/circularLoading";


const ProviderServicePracticeForm = ({ loading, editing }) => {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();
  const subnomenclatures = useSelector((state) => state.providedServices.subnomenclatures.data);
  const providerServices = useSelector((state) => state.providedServices.providerServicesByNomenclature.data);
  const providers = useSelector((state) => state.providers.listProviders.list);
  const arts = useSelector((state) => state.arts.list);

  return (
    <>
      {!loading ? (
        <>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikSelect
              disabled={editing}
              name="art" label="Art" callBack={(value) => {
                if (!value) {
                  setFieldValue("subnomenclador", "");
                } else {
                  if (value != values["art"]) {
                    dispatch(getNomenclatures(value));
                    setFieldValue("subnomenclador", "");
                  }
                }

              }}>
              {arts.map((art) => (
                <MenuItem value={art.id} key={art.id}>
                  {art.nombre}
                </MenuItem>
              ))}
            </FormikSelect>
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikSelect
              disabled={editing}
              name="prestador"
              label="Prestador"
              variant="standard">
              {providers.map((provider) => (
                <MenuItem key={provider.id} value={provider.id}>
                  {provider.nombre}
                </MenuItem>
              ))}
            </FormikSelect>
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikAutocomplete
              disabled={editing || !values["art"]}
              name="subnomenclador"
              label="Subnomenclador"
              options={subnomenclatures}
              getOptions={() => dispatch(getNomenclatures(values["art"]))}
            />
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikAutocomplete
              disabled={editing || !values["subnomenclador"]}
              name="prestacion"
              label="Prestacion"
              options={providerServices}
              labelOption={option => `${option.prestacion}`}
              returnProp="prestacion"
              getOptions={() => dispatch(getProviderServicesByNomenclature(values["art"], values["subnomenclador"]))}
              filterOptions={(option) => option.prestacion + " " + option.nombrePrestacion}
              renderOption={(option) => `${option.prestacion} ${option.nombrePrestacion}`}
              callBack={(option) => {
                if (option) {
                  setFieldValue("nombre", option.nombrePrestacion);
                  setFieldValue("descripcion", option.descripcionPrestacion);
                } else {
                  setFieldValue("nombre", "");
                  setFieldValue("descripcion", "");
                }
              }}
            />
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikTextField
              name="nombre"
              label="Nombre"
              disabled
            />
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikTextField
              name="descripcion"
              label="Descripción"
              disabled
            />
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
          <StyledProviderProvidedServiceForm.StyledHorizontalInput>
            <FormikSwitch
              name="habilitada"
              label="Habilitada"
            />
          </StyledProviderProvidedServiceForm.StyledHorizontalInput>
        </>
      ) : (
        <CircularLoading />
      )}
    </>
  )
}

export default ProviderServicePracticeForm;